var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState, useEffect } from 'react';
import SwiperCore, { Virtual, Navigation } from 'swiper';
import ArticleRelatedCard from '../../Cards/ContentCard';
import './Carousel.scss';
SwiperCore.use([Virtual, Navigation]);
import '../../../lib/styles/swiper.scss';
import { useWindowSize } from '../../../hooks/useWindowSize';
import { TwoCards } from '../../childCardsContentCardsv2/TwoCards';
import AliceCarousel from 'react-alice-carousel';
var handleDragStart = function (e) { return e.preventDefault(); };
var SwiperCarousel = function (_a) {
    var title = _a.title, cardsArray = _a.cardsArray;
    var width = useWindowSize()[0];
    var isMobile = width < 768;
    var isTablet = window.innerWidth < 1024;
    var isDesktop = window.innerWidth >= 1440;
    var _b = useState(0), activeMobile = _b[0], setActiveMobile = _b[1];
    var _c = useState(0), scrolledBy = _c[0], setScrolledBy = _c[1];
    var resourceCardList = cardsArray;
    var data = { title: title, resourceCardList: resourceCardList };
    var _d = useState(0), itemNumber = _d[0], updateItemNumber = _d[1];
    var _e = useState(0), maxItemNum = _e[0], updateMaxItemNum = _e[1];
    var stateRef = useRef();
    var maxStateRef = useRef();
    var aliceRef = useRef();
    var shadowArrowsRefArticles = useRef();
    stateRef.current = itemNumber;
    maxStateRef.current = maxItemNum;
    var scrollRef = useRef();
    scrollRef.current = scrolledBy;
    var items = [];
    var responsive = {
        // 0: { items: 1 },
        // 568: { items: 2 },
        1024: { items: 2.3 },
        1100: { items: 2.4 },
        1150: { items: 2.5 },
        1200: { items: 2.6 },
        1300: { items: 2.8 },
        1440: { items: 3.4 },
        1600: { items: 3.7 },
        1800: { items: 4.3 },
        2200: { items: 4.5 },
        2400: { items: 4.7 },
        2600: { items: 5 },
        // 3000: { items: 5 },
    };
    cardsArray.map(function (contentProps, index) {
        return items.push(_jsx(ArticleRelatedCard, { title: contentProps.title, date: contentProps.date, image: contentProps.image, imgAlt: contentProps.imgAlt, articleLink: contentProps.cta.url }, void 0));
    });
    var mainArea = React.useMemo(function () { return (_jsx(AliceCarousel, { mouseTracking: true, items: items, responsive: responsive, disableDotsControls: true, onSlideChanged: function (e) {
            slideChangedCustomMethod(e);
        }, renderPrevButton: function () {
            return (_jsx("p", __assign({ className: "absolute hover-state  hover-state-left", style: {
                    color: 'black',
                    top: '5px',
                    right: '212px',
                    width: '40px',
                } }, { children: _jsxs("svg", __assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", stroke: "#0074bd" }, void 0),
                        _jsx("path", { d: "m22.306 14.617-5.384 5.385 5.384 5.384", stroke: "#0074bd" }, void 0)] }), void 0) }), void 0));
        }, renderNextButton: function () {
            return (_jsx("p", __assign({ className: "absolute hover-state hover-state-right", style: {
                    color: 'black',
                    top: '5px',
                    right: '156px',
                    width: '40px',
                } }, { children: _jsxs("svg", __assign({ width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", transform: "matrix(-1 0 0 1 40 0)", stroke: "#0074bd" }, void 0),
                        _jsx("path", { d: "m17.694 14.617 5.384 5.385-5.384 5.384", stroke: "#0074bd" }, void 0)] }), void 0) }), void 0));
        } }, void 0)); }, [window.innerWidth]);
    useEffect(function () {
        if (window.innerWidth >= 1024 && cardsArray.length > 3) {
            setTimeout(function () {
                var _a;
                var myArray = Array.from(document.getElementsByClassName('alice-carousel'));
                myArray.map(function (item, i) {
                    item.setAttribute('style', 'position:initial');
                });
                var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                (_a = slidePrev[0]) === null || _a === void 0 ? void 0 : _a.setAttribute('style', 'display:none; padding:0px 0px');
                if ((window.innerWidth >= 1024 &&
                    window.innerWidth < 1440 &&
                    cardsArray.length > 2) ||
                    (window.innerWidth >= 1440 &&
                        window.innerWidth < 1800 &&
                        cardsArray.length > 3) ||
                    (window.innerWidth >= 1800 &&
                        window.innerWidth < 2600 &&
                        cardsArray.length > 4) ||
                    (window.innerWidth >= 2600 && cardsArray.length > 5)) {
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                }
                else {
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:none; padding:0px 0px');
                }
            }, 10);
        }
        if ((window.innerWidth >= 1800 &&
            window.innerWidth < 2600 &&
            cardsArray.length == 4) ||
            (window.innerWidth >= 2600 && cardsArray.length <= 5)) {
            setTimeout(function () {
                var _a;
                (_a = shadowArrowsRefArticles === null || shadowArrowsRefArticles === void 0 ? void 0 : shadowArrowsRefArticles.current) === null || _a === void 0 ? void 0 : _a.setAttribute('style', 'display:none;');
            }, 10);
        }
        else if (window.innerWidth >= 1024) {
            setTimeout(function () {
                var _a;
                (_a = shadowArrowsRefArticles === null || shadowArrowsRefArticles === void 0 ? void 0 : shadowArrowsRefArticles.current) === null || _a === void 0 ? void 0 : _a.setAttribute('style', 'display:block;position: relative; width: 96px');
            }, 10);
        }
        setScrolledBy(0);
        updateItemNumber(0);
    }, [window.innerWidth]);
    var slideChangedCustomMethod = function (e) {
        if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
            if (e.item == 0) {
                setTimeout(function () {
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:none; padding:0px 0px');
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            else if (e.item == cardsArray.length - 2) {
                setTimeout(function () {
                    if (e.item == 1 && e.item == cardsArray.length - 2) {
                        var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                        slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                    }
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:none; padding:0px 0px');
                }, 10);
            }
            else {
                setTimeout(function () {
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            if (e.item <= cardsArray.length - 2) {
                if (e.item > stateRef.current && e.item <= (cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 2) {
                    updateItemNumber(function (number) { return number + 1; });
                    setScrolledBy(function (currCount) { return currCount + 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 1); });
                }
                else {
                    if (scrollRef.current > 0 && e.item < cardsArray.length - 2) {
                        setScrolledBy(function (currCount) { return currCount - 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 1); });
                        updateItemNumber(function (number) { return number - 1; });
                    }
                }
            }
        }
        if (window.innerWidth >= 1440 && window.innerWidth < 1800) {
            if (e.item == 0) {
                setTimeout(function () {
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:none; padding:0px 0px');
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            else if (e.item == cardsArray.length - 3) {
                setTimeout(function () {
                    if (e.item == 1 && e.item == cardsArray.length - 3) {
                        var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                        slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                    }
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:none; padding:0px 0px');
                }, 10);
            }
            else {
                setTimeout(function () {
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            if (e.item < cardsArray.length - 2) {
                if (e.item > stateRef.current && e.item <= (cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 3) {
                    updateItemNumber(function (number) { return number + 1; });
                    setScrolledBy(function (currCount) { return currCount + 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 2); });
                }
                else {
                    if (scrollRef.current > 0 && e.item < cardsArray.length - 3) {
                        setScrolledBy(function (currCount) { return currCount - 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 2); });
                        updateItemNumber(function (number) { return number - 1; });
                    }
                }
            }
        }
        else if (window.innerWidth >= 1800 &&
            window.innerWidth < 2600 &&
            cardsArray.length !== 4) {
            if (e.item == 0) {
                setTimeout(function () {
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:none; padding:0px 0px');
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            else if (e.item == cardsArray.length - 4) {
                setTimeout(function () {
                    if (e.item == 1 && e.item == cardsArray.length - 4) {
                        var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                        slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                    }
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:none; padding:0px 0px');
                }, 10);
            }
            else {
                setTimeout(function () {
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            if (e.item < cardsArray.length - 3) {
                if (e.item > stateRef.current && e.item <= (cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 4) {
                    updateItemNumber(function (number) { return number + 1; });
                    setScrolledBy(function (currCount) { return currCount + 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 3); });
                }
                else {
                    if (scrollRef.current > 0 && e.item < cardsArray.length - 4) {
                        setScrolledBy(function (currCount) { return currCount - 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 3); });
                        updateItemNumber(function (number) { return number - 1; });
                    }
                }
            }
        }
        else if (window.innerWidth >= 2600 && cardsArray.length > 5) {
            if (e.item == 0) {
                setTimeout(function () {
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:none; padding:0px 0px');
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            else if (e.item == cardsArray.length - 5) {
                setTimeout(function () {
                    if (e.item == 1 && e.item == cardsArray.length - 5) {
                        var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                        slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                    }
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:none; padding:0px 0px');
                }, 10);
            }
            else {
                setTimeout(function () {
                    var slideNext = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__next-btn'));
                    slideNext[0].setAttribute('style', 'display:block; padding:0px 0px');
                    var slidePrev = Array.from(aliceRef.current.getElementsByClassName('alice-carousel__prev-btn'));
                    slidePrev[0].setAttribute('style', 'display:block; padding:0px 0px');
                }, 10);
            }
            if (e.item < cardsArray.length - 4) {
                if (e.item > stateRef.current && e.item <= (cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 5) {
                    updateItemNumber(function (number) { return number + 1; });
                    setScrolledBy(function (currCount) { return currCount + 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 4); });
                }
                else {
                    if (scrollRef.current > 0 && e.item < cardsArray.length - 5) {
                        setScrolledBy(function (currCount) { return currCount - 100 / ((cardsArray === null || cardsArray === void 0 ? void 0 : cardsArray.length) - 4); });
                        updateItemNumber(function (number) { return number - 1; });
                    }
                }
            }
        }
    };
    // useEffect(() => {
    //   const tl = gsap.timeline({
    //     scrollTrigger: {
    //       trigger: '.card-carousel-anime',
    //       start: 'top center',
    //     },
    //   });
    //   tl.to('.card-carousel-anime', {
    //     autoAlpha: 1,
    //     duration: 1,
    //     stagger: {
    //       each: 0.5,
    //     },
    //   });
    // });
    return isMobile || isTablet || cardsArray.length < 4 ? (_jsx(TwoCards, { title: title, contentCardList: cardsArray }, void 0)) : (_jsxs("div", __assign({ className: "relative", ref: aliceRef }, { children: [_jsxs("div", __assign({ className: "leading-padding" }, { children: [_jsxs("div", __assign({ className: "flex justify-between " }, { children: [_jsx("p", __assign({ className: "mb-4 px-[24px] text-[18px] leading-[1.33] text-[#343741] md:mb-4 md:px-[45px] md:text-[22px] md:leading-[1.45] lg:text-[32px] lg:leading-[1.25] twocards_title" }, { children: title }), void 0),
                            _jsxs("div", __assign({ ref: shadowArrowsRefArticles, style: { position: 'relative', width: '96px' } }, { children: [_jsxs("svg", __assign({ style: {
                                            position: 'absolute',
                                            left: '0px',
                                            opacity: '0.3',
                                            top: '5px',
                                        }, width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", stroke: "#0074bd" }, void 0),
                                            _jsx("path", { d: "m22.306 14.617-5.384 5.385 5.384 5.384", stroke: "#0074bd" }, void 0)] }), void 0),
                                    _jsxs("svg", __assign({ style: {
                                            position: 'absolute',
                                            right: '0px',
                                            opacity: '0.3',
                                            top: '5px',
                                        }, width: "40", height: "40", viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("circle", { cx: "20", cy: "20", r: "19.5", transform: "matrix(-1 0 0 1 40 0)", stroke: "#0074bd" }, void 0),
                                            _jsx("path", { d: "m17.694 14.617 5.384 5.385-5.384 5.384", stroke: "#0074bd" }, void 0)] }), void 0)] }), void 0)] }), void 0),
                    _jsx("hr", { className: "header-divider md:block ", style: { borderTop: 'solid 1px #d8dcdb' } }, void 0)] }), void 0), mainArea, _jsx("div", __assign({ className: " h-[1px] leading-padding\n\n        ", style: {
                    backgroundColor: 'rgba(0, 95, 158, 0.2)',
                    // width: 'calc(100% - 48px)',
                    width: 'calc(100%)',
                    marginTop: '48px',
                } }, { children: _jsx("div", { className: "ml-[px] h-full  bg-[#2d7fb6]", style: {
                        marginLeft: "calc(" + scrolledBy + "%)",
                        width: "" + (window.innerWidth >= 1024 && window.innerWidth < 1440
                            ? "calc(100% / " + (cardsArray.length - 1 > 0 ? cardsArray.length - 1 : 1) + ")"
                            : window.innerWidth >= 1440 && window.innerWidth < 1800
                                ? "calc(100% / " + (cardsArray.length - 2 > 0 ? cardsArray.length - 2 : 1) + ")"
                                : window.innerWidth >= 1800 && window.innerWidth < 2600
                                    ? "calc(100% / " + (cardsArray.length - 3 > 0 ? cardsArray.length - 3 : 1) + ")"
                                    : window.innerWidth >= 2600
                                        ? "calc(100% / " + (cardsArray.length - 4 > 0 ? cardsArray.length - 4 : 1) + ")"
                                        : ''),
                    } }, void 0) }), void 0)] }), void 0));
};
export default SwiperCarousel;
